import PageHeader from '../components/PageHeader.jsx';
import Founder from '../components/Founder.jsx';
import SnapPage from '../components/SnapPage.jsx';
import T from '../i18n/content.js';
import { useT } from '../i18n/LangContext.jsx';

export default function FounderPage() {
  const t = useT();
  const S = T.founderSec;
  // Render any "\n" in the title as a line break so CN reads 本所 / 创始人
  // (instead of width-driven wrapping that splits 创始人). EN has no "\n".
  const title = t(S.pageTitle).split('\n').reduce(
    (acc, line, i) => (i === 0 ? [line] : [...acc, <br key={i} />, line]),
    [],
  );
  return (
    <SnapPage>
      <PageHeader title={title} lede={t(S.lede)} motif="motif-founder.png" motifSize="lg" lower />
      <Founder asPage />
    </SnapPage>
  );
}
